import { List, ListItem, styled, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  listStyleType: 'none',
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: 0,
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[50],
  fontSize: 16,
}));

export const StyledCheckIcon = styled(CheckIcon)({
  fontSize: 'inherit',
  color: 'inherit',
});

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: 'inherit',
  color: theme.palette.primary.main,
}));
